import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-package-03',
  standalone: true,
  templateUrl: '../../assets/package-03.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamPackage03Icon {}
